module.exports = __webpack_public_path__ + "static/no-tree-nuts-2ddb8598a0e24356de5b0d8cc760ae41.png";